export interface DestinationInterface {
  imageForCard: string;
  displayNameForCard: string;
  cityId: string;
  cityName: string;
  countryId: string;
  countryName: string;
  cssClass: string;
  destinationId: string;
  displayName: string;
  id: string;
  imgIcon: string;
  keywordId: string;
  language: string;
  latitude: string;
  locationId: null;
  longitude: string;
  slug: string;
  tableSlug: string;
  tableSlugText: string;
  totalCount: string;
  countrySlug: string;
  citySlug: string;
  areaSlug: null;
  isCampaign: boolean;
  label?: string;
  displayKey?: "displayName" | "displayNameForCard";
  description?: string;
}
export interface ExperienceInterface {
  experienceId: string;
  name: string;
  slug: string;
  ticketCategoryId: string;
  isCampaign: string;
  isComingSoon: string;
  category: string;

  photoPath: string | null;
  description: string | null;
  ticketType: string;
  citySlug: string;
  countrySlug: string;
  label?: string;
}

export interface ResponseSearchExperienceInterface {
  experienceId: string;
  name: string;
  slug: string;
  citySlug: string;
  countrySlug: string;
  ticket_category_id: string;
  photoPath: string;
  isCampaign: string;
  category: string;
  description: string;
  isComingSoon: boolean;
  ticketType: string;
  label?: string;
}

export interface ExperienceDestinationDataInterface {
  experience: ExperienceInterface[] | [];
  destination: DestinationInterface[] | [];
}

export const mapDestinationData = (
  destination: any,
): DestinationInterface[] => {
  try {
    const mapData = destination.map((item: DestinationInterface) => ({
      imageForCard: item?.imageForCard || "",
      displayNameForCard: item?.displayNameForCard || "",
      cityId: item?.cityId || null,
      cityName: item?.cityName || "",
      countryId: item?.countryId || null,
      countryName: item?.countryName || "",
      cssClass: item?.cssClass || "",
      destinationId: item?.destinationId || null,
      displayName: item?.displayName || null,
      id: item?.id || "",
      imgIcon: item?.imgIcon || "",
      keywordId: item?.keywordId || "",
      language: item?.language || "",
      latitude: item?.latitude || "",
      locationId: item?.locationId || null,
      longitude: item?.longitude || "",
      slug: item?.slug || "",
      tableSlug: item?.tableSlug || "",
      tableSlugText: item?.tableSlugText || "",
      totalCount: item?.totalCount || "",
      countrySlug: item?.countrySlug || "",
      citySlug: item?.citySlug || "",
      areaSlug: item?.areaSlug || null,
      isCampaign: item?.isCampaign || false,
      name: item?.displayName || "",
      photoPath: item?.imageForCard,
      description: item?.description || item?.countrySlug,
      label: item?.label || "",
      displayKey: item?.displayKey || "",
    }));
    return mapData;
  } catch (error) {
    // console.error(error);
    return [];
  }
};
export class ResponseDestination {
  status: boolean = true;

  message: null | string = null;

  data: ExperienceDestinationDataInterface = {
    destination: [],
    experience: [],
  };

  constructor(data?: any) {
    if (!data) return;
    const { data: destinationData, status, message } = data;
    this.status = !!status;
    this.message = message || "";
    const mapData = mapDestinationData(destinationData?.destination || []);
    this.data = {
      destination: mapData,
      experience:
        destinationData?.experience.map(
          (item: ResponseSearchExperienceInterface) => ({
            experienceId: item?.experienceId || "",
            name: item?.name || "",
            slug: item?.slug || "",
            ticketCategoryId: item?.ticket_category_id || "",
            isCampaign: item?.isCampaign || "",
            isComingSoon: item?.isComingSoon || "",
            category: item?.category || "",
            photoPath: item?.photoPath || null,
            description: item?.description || null,
            ticketType: item?.ticketType || "",
            citySlug: item?.citySlug || "",
            countrySlug: item?.countrySlug || "",
            label: item?.label || "",
          }),
        ) || [],
    };
  }
}
